/* eslint-disable consistent-return */
import produce from 'immer';

const INITIAL_STATE = {
  phase: 'idle',
  migrationData: null,
  bannerDismissed: false,
};

function derivePhase(status) {
  if (status === 'COMPLETED') return 'completed';
  if (status === 'FAILED') return 'failed';
  if (status === 'IN_PROGRESS' || status === 'RETRYING' || status === 'PENDING')
    return 'in_progress';
  return 'idle';
}

export default function migration(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@migration/UPDATE_STATUS': {
        const { data } = action.payload;
        draft.migrationData = data;
        draft.phase = derivePhase(data.status);
        if (draft.phase === 'in_progress') {
          draft.bannerDismissed = false;
        }
        break;
      }
      case '@migration/RESET': {
        draft.phase = 'idle';
        draft.migrationData = null;
        draft.bannerDismissed = false;
        break;
      }
      case '@migration/DISMISS_BANNER': {
        draft.bannerDismissed = true;
        break;
      }
      case '@auth/SIGN_OUT': {
        draft.phase = 'idle';
        draft.migrationData = null;
        draft.bannerDismissed = false;
        break;
      }
      default:
        return state;
    }
  });
}
